import "bootstrap/dist/css/bootstrap.css";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import ScrollToTop from "./components/layout/ScrollToTop";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <HelmetProvider>
        <BrowserRouter basename={baseUrl}>
            <ScrollToTop />
            <App/>
        </BrowserRouter>
    </HelmetProvider>
);
